import { countries } from 'countries-list';

export const phoneNumberCountryCodeLocalization = Object.keys(countries).reduce((acc, key) => {
  acc[key] = countries[key].native;
  return acc;
}, {});
